function getItemsToDisplayIds(itemsToDisplay) {
  if (!itemsToDisplay || !itemsToDisplay.length) return [];
  const ids = itemsToDisplay.reduce((acc, {
    displayItems
  }) => {
    if (!displayItems || !displayItems.length) return acc;
    return acc.concat(displayItems);
  }, []);
  return [...new Set([...ids])];
}
export default getItemsToDisplayIds;
//# sourceMappingURL=get-items-to-display-ids.js.map